import AccountGetter from "./account.getter";
import LoaderGetter from "./loader.getter";
import QuestionGetter from "./question.getter";
import NotificationGetter from "./notification.getter";
import TransactionGetter from "./transaction.getter";
import UserGetter from "./user.getter";
import PlanGetter from "./plan.getter";
import SettingsGetter from "./settings.getter";
import BankAccountGetter from "./bankAccount.getter";
import WithdrawGetter from "./withdraw.getter";
import VasGetter from "./vas.getter";
import RateGetter from "./rate.getter";
import AppGetter from "./app.getter";
import BusinessGetter from "./business.getter";
import SubscriptionGetter from "./subscription.getter";
import DisputeGetter from "./dispute.getter";
import CardGetter from "./card.getter";
import WalletGetter from "./wallet.getter";

const getters = {
    ...SettingsGetter,
    ...TransactionGetter,
    ...UserGetter,
    ...PlanGetter,
    ...LoaderGetter,
    ...NotificationGetter,
    ...AccountGetter,
    ...QuestionGetter,
    ...BankAccountGetter,
    ...WithdrawGetter,
    ...VasGetter,
    ...RateGetter,
    ...AppGetter,
    ...BusinessGetter,
    ...SubscriptionGetter,
    ...DisputeGetter,
    ...CardGetter,
    ...WalletGetter
};

export default getters;